import { render, staticRenderFns } from "./ProgramTab.vue?vue&type=template&id=c5f9614e&scoped=true&"
import script from "./ProgramTab.vue?vue&type=script&lang=js&"
export * from "./ProgramTab.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTab.vue?vue&type=style&index=0&id=c5f9614e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f9614e",
  null
  
)

export default component.exports